import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { PACKAGE_NAME, TEAM } from '../../common/constants';
import type { MovePrioritiesRequestParams } from '../../common/types';

export const MOVE_PRIORITIES_API = '/rest/api/3/priority/move';

/**
 * Updates the order of priorities.
 * @param movePrioritiesRequest - The request object containing the details of the priorities to be moved.
 * @returns A promise that resolves to the response from the server.
 * @throws If an error occurs during the update process.
 */
export const updatePrioritiesOrder = async (
	movePrioritiesRequestParams: MovePrioritiesRequestParams,
) => {
	try {
		const response = await performPutRequest(`${MOVE_PRIORITIES_API}`, {
			body: JSON.stringify(movePrioritiesRequestParams),
		});
		return response;
	} catch (error) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'updatePrioritiesOrder',
					packageName: PACKAGE_NAME,
					teamName: TEAM,
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};
